import { render, staticRenderFns } from "./equityCardWriteOffRecord.vue?vue&type=template&id=9c604918&scoped=true"
import script from "./equityCardWriteOffRecord.vue?vue&type=script&lang=js"
export * from "./equityCardWriteOffRecord.vue?vue&type=script&lang=js"
import style0 from "./equityCardWriteOffRecord.vue?vue&type=style&index=0&id=9c604918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c604918",
  null
  
)

export default component.exports